import {CallToActionType} from '~/enums/processFlows/callToActionType'
import {IDefaultVOption} from '~/interfaces/vSelectInterfaces'

export default class ProcessFlowStepCallToActionDefinition {
  static variableReferenceLabel(type: CallToActionType): string {
    switch (type) {
      case CallToActionType.ViewRecord:
        return 'Select a record'
      case CallToActionType.EditFormSubmission: // fallthrough
      case CallToActionType.ViewFormSubmission:
        return 'Select a form submission'
      case CallToActionType.File:
        return 'Select a file'
      default:
        return 'Select a variable'
    }
  }

  static variableReferencePlaceholder(type: CallToActionType): string {
    switch (type) {
      case CallToActionType.ViewRecord:
        return 'Search an object model...'
      case CallToActionType.EditFormSubmission: // fallthrough
      case CallToActionType.ViewFormSubmission:
        return 'Search a form...'
      case CallToActionType.File:
        return 'Search a file...'
      default:
        return 'Search a variable...'
    }
  }

  static typeSelectOption(type: CallToActionType): IDefaultVOption<CallToActionType> {
    switch (type) {
      case CallToActionType.EditFormSubmission:
        return { label: 'Edit form submission', value: CallToActionType.EditFormSubmission }
      case CallToActionType.ViewFormSubmission:
        return { label: 'View form submission', value: CallToActionType.ViewFormSubmission }
      case CallToActionType.ViewRecord:
        return { label: 'View record', value: CallToActionType.ViewRecord }
      case CallToActionType.FormProfile:
        return { label: 'Form profile', value: CallToActionType.FormProfile }
      case CallToActionType.NewFormSubmission:
        return { label: 'New form submission', value: CallToActionType.NewFormSubmission }
      case CallToActionType.ListView:
        return { label: 'List view', value: CallToActionType.ListView }
      case CallToActionType.File:
        return { label: 'File', value: CallToActionType.File }
    }
  }
}